import { Loading } from '@/components/loading';
import { ProjectBasicInfoTable } from '@/components/tables/project-basic-info-table';
import { ProjectFarmSummaryTable } from '@/components/tables/project-farm-summary-table.component';
import { cn } from '@/lib/utils';
import { useProjectBasicDetailsData, useProjectFarmSummaryData } from '@/modules/Report/Report.api';
import { toast } from 'react-toastify';

import { Project } from '../Customers/Customers.api';

type Props = {
  projectData: Project;
};

export const ProjectDetailList = ({ projectData }: Props) => {
  const { data: farmSummaries, status: farmSummaryStatus } = useProjectFarmSummaryData(projectData.project_id);
  const { data: basicDetails, status: basicDetailsStatus } = useProjectBasicDetailsData(projectData.project_id);

  if (basicDetailsStatus === 'error') {
    toast.error('Failed to fetch project details');
    return null;
  }

  if (basicDetailsStatus === 'pending') {
    return <Loading />;
  }

  if (!basicDetails) {
    return null;
  }

  const hasFarmData = farmSummaryStatus === 'success' && Array.isArray(farmSummaries) && farmSummaries.length > 0;

  return (
    <div className={cn('mt-4 mb-10 flex flex-col gap-6')}>
      <ProjectBasicInfoTable data={basicDetails} className={cn('shadow p-5')} />
      {farmSummaryStatus === 'pending' ? (
        <Loading />
      ) : hasFarmData ? (
        <ProjectFarmSummaryTable
          customerId={projectData.breadcrumb.client.id}
          projectId={projectData.breadcrumb.project.id}
          projectFarmSummaries={farmSummaries!}
          enableFarmLinks={projectData.reporting_type !== 'project_only'}
        />
      ) : null}
    </div>
  );
};
